export class GetActiveStateError extends Error {
    public readonly name: string;
    public readonly stack: string;

    constructor(message: string, stack: string = '') {
        super(message);
        this.name = 'GetActiveStateError';
        this.stack = stack;
        Object.setPrototypeOf(this, GetActiveStateError.prototype);
    }
}
